import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import useBreakpoint from '~/composables/useBreakpoint';
import { getAssetUrl } from '~/composables/useMediaAsset';
import CategoryFeaturesBlocks from '~/components/sections/categorySection/CategoryFeaturesBlocks.vue';
import CategoryFeaturesBlocksMobile from '~/components/sections/categorySection/CategoryFeaturesBlocksMobile.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryFeatures',
  props: {
  data: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {

const props = __props;



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const items = computed(() =>
  (props.data as Record<string, any>[]).map((item) => ({
    ...item,
    image: getAssetUrl(item.image),
  })),
);

return { __sfc: true,props, isDesktop, items, CategoryFeaturesBlocks, CategoryFeaturesBlocksMobile }
}

})